import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "flexRow" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-sm-6" }
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = { class: "col-sm-1" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-times" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "col-sm-3" }
const _hoisted_10 = ["onUpdate:modelValue"]
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "col-sm-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Orario di "),
  /*#__PURE__*/_createElementVNode("b", { class: "fs-14" }, "INIZIO"),
  /*#__PURE__*/_createTextVNode(" per apertura ticket "),
  /*#__PURE__*/_createElementVNode("small", null, "(se non va in automatico, usare il formato HH:mm)")
], -1)
const _hoisted_14 = ["onUpdate:modelValue"]
const _hoisted_15 = { class: "col-sm-4" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Orario di "),
  /*#__PURE__*/_createElementVNode("b", { class: "fs-14" }, "FINE"),
  /*#__PURE__*/_createTextVNode(" per apertura ticket "),
  /*#__PURE__*/_createElementVNode("small", null, "(se non va in automatico, usare il formato HH:mm)")
], -1)
const _hoisted_17 = ["onUpdate:modelValue"]
const _hoisted_18 = { class: "col-sm-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_tiny_editor = _resolveComponent("tiny-editor")!
  const _component_accordion = _resolveComponent("accordion")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_accordion, null, {
      title: _withCtx(() => [
        _createElementVNode("h3", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "Primo messaggio per apertura ticket (ciao, il servizio è attivo dalle alle...)",
            text: "Primo messaggio per apertura ticket (ciao, il servizio è attivo dalle alle...)"
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_tiny_editor, {
          modelValue: _ctx.config.primoMessaggioAperturaTicket,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.config.primoMessaggioAperturaTicket) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_accordion, null, {
      title: _withCtx(() => [
        _createElementVNode("h3", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "Orari di apertura ticket",
            text: "Orari di apertura ticket"
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h5", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Orari di apertura ticket",
                text: "Orari di apertura ticket"
              })
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-success",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addTime && _ctx.addTime(...args)))
              }, "Aggiungi orario")
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.config.orariTicket.times, (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "row",
                key: i
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-danger",
                    onClick: ($event: any) => (_ctx.removeTime(i))
                  }, _hoisted_8, 8, _hoisted_6)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("label", null, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Giorno",
                      text: "Giorno"
                    })
                  ]),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-control",
                    "onUpdate:modelValue": ($event: any) => ((item.day) = $event)
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.days, (day, i) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: i,
                        value: i
                      }, _toDisplayString(day), 9, _hoisted_11))
                    }), 128))
                  ], 8, _hoisted_10), [
                    [_vModelSelect, item.day]
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _withDirectives(_createElementVNode("input", {
                    type: "time",
                    class: "form-control",
                    "onUpdate:modelValue": ($event: any) => ((item.startTime) = $event)
                  }, null, 8, _hoisted_14), [
                    [_vModelText, item.startTime]
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _withDirectives(_createElementVNode("input", {
                    type: "time",
                    class: "form-control",
                    "onUpdate:modelValue": ($event: any) => ((item.endTime) = $event)
                  }, null, 8, _hoisted_17), [
                    [_vModelText, item.endTime]
                  ])
                ])
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("h5", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Messaggio degli orari",
                text: "Messaggio degli orari"
              })
            ]),
            _createVNode(_component_tiny_editor, {
              modelValue: _ctx.config.orariTicket.text,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.config.orariTicket.text) = $event))
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("button", {
      type: "submit",
      class: "btn btn-primary pull-right my-3",
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
    }, [
      _createVNode(_component_localized_text, {
        localizedKey: "Salva testo",
        text: "Salva testo"
      })
    ])
  ]))
}